module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "linear-gradient(#3B7EFE, #33CEFC)"
    }
  }, [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "3.5rem"
    }
  }, [_c('ul', {
    staticClass: "ul"
  }, [_c('li', [_c('div', {
    staticClass: "item-content height"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.focus('account')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "account",
      "placeholder": "手机/邮箱/帐号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])]), _vm._v(" "), (_vm.isSalesFlag) ? _c('ul', {
    staticClass: "ul"
  }, [_c('li', [_c('div', {
    staticClass: "item-content height"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.focus('sfaccount')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerNo),
      expression: "customerNo",
      modifiers: {
        "trim": true
      }
    }],
    style: ({
      color: _vm.error
    }),
    attrs: {
      "id": "sfaccount",
      "type": "text",
      "placeholder": "客户编号"
    },
    domProps: {
      "value": (_vm.customerNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerNo = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "ul"
  }, [_c('li', [_c('div', {
    staticClass: "item-content height"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.focus('password')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "delete-password",
    attrs: {
      "src": "/static/img/delete.png"
    },
    on: {
      "click": _vm.deletePassword
    }
  }), _vm._v(" "), (_vm.showPassword) ? _c('img', {
    staticClass: "show-password",
    attrs: {
      "src": "/static/img/display-password.png"
    },
    on: {
      "click": _vm.toggleShowPassword
    }
  }) : _c('img', {
    staticClass: "show-password",
    attrs: {
      "src": "/static/img/hide-password.png"
    },
    on: {
      "click": _vm.toggleShowPassword
    }
  })])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-settings"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-2.4rem",
      "margin-left": "0",
      "text-align": "center"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "block3"
  }, [_c('div', {
    staticClass: "left",
    attrs: {
      "onclick": "window.open('https://beian.miit.gov.cn/')",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备17040580号-1")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "icon2",
    attrs: {
      "referrerpolicy": "no-referrer",
      "src": "static/img/ba.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info3"
  }, [_vm._v("沪公网安备 31011502400053号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14d565ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyLogin/Login.vue
// module id = 1545
// module chunks = 8